module.exports = __webpack_public_path__ + "static/media/logo.2131d04b.svg";